import { defineMessages } from 'react-intl';

/** The copy of the asset viewer (design music24-asset-viewer a1..a6). */
export const viewerMessages = defineMessages({
  dialogLabel: { id: 'app.sml.promote.viewer.dialogLabel', defaultMessage: '{name} of {title}' },
  close: { id: 'app.sml.promote.viewer.close', defaultMessage: 'Close' },
  previous: { id: 'app.sml.promote.viewer.previous', defaultMessage: 'Previous asset' },
  next: { id: 'app.sml.promote.viewer.next', defaultMessage: 'Next asset' },
  count: { id: 'app.sml.promote.viewer.count', defaultMessage: '{index} / {count}' },
  keysClose: { id: 'app.sml.promote.viewer.keys.close', defaultMessage: 'Close' },
  keysMove: { id: 'app.sml.promote.viewer.keys.move', defaultMessage: 'Previous or next asset' },
  keysPlay: { id: 'app.sml.promote.viewer.keys.play', defaultMessage: 'Play or pause' },
  open: { id: 'app.sml.promote.viewer.open', defaultMessage: 'View' },
  openLabel: { id: 'app.sml.promote.viewer.openLabel', defaultMessage: 'Open {name} in the viewer' },
  factSize: { id: 'app.sml.promote.viewer.fact.size', defaultMessage: 'Size' },
  factLength: { id: 'app.sml.promote.viewer.fact.length', defaultMessage: 'Length' },
  factFile: { id: 'app.sml.promote.viewer.fact.file', defaultMessage: 'File' },
  factVersion: { id: 'app.sml.promote.viewer.fact.version', defaultMessage: 'Revision' },
  factMade: { id: 'app.sml.promote.viewer.fact.made', defaultMessage: 'Made' },
  megabytes: { id: 'app.sml.promote.viewer.megabytes', defaultMessage: '{value} MB' },
  kilobytes: { id: 'app.sml.promote.viewer.kilobytes', defaultMessage: '{value} KB' },
  versionLatest: { id: 'app.sml.promote.viewer.versionLatest', defaultMessage: 'r{version} · newest' },
  versionShort: { id: 'app.sml.promote.viewer.versionShort', defaultMessage: 'r{version}' },
  download: { id: 'app.sml.promote.viewer.download', defaultMessage: 'Download' },
  proResDownload: {
    id: 'app.sml.promote.viewer.prores.download',
    defaultMessage: 'Download ProRes for distributor',
  },
  proResMake: { id: 'app.sml.promote.viewer.prores.make', defaultMessage: 'Make ProRes for distributor' },
  proResWorking: { id: 'app.sml.promote.viewer.prores.working', defaultMessage: 'Making the ProRes file…' },
  proResLocked: { id: 'app.sml.promote.viewer.prores.locked', defaultMessage: 'ProRes for distributors is on Pro' },
  proResHint: {
    id: 'app.sml.promote.viewer.prores.hint',
    defaultMessage:
      'A ProRes 422 HQ file for distributors that ask for it (about 1 to 3 GB). We keep it for 7 days. It is not in the kit zip.',
  },
  proResReady: { id: 'app.sml.promote.viewer.prores.ready', defaultMessage: 'Ready until {date}' },
  proResFailed: {
    id: 'app.sml.promote.viewer.prores.failed',
    defaultMessage: 'We could not make the ProRes file. Try again.',
  },
  shareTitle: { id: 'app.sml.promote.viewer.share.title', defaultMessage: 'Public link' },
  shareOnTitle: { id: 'app.sml.promote.viewer.share.onTitle', defaultMessage: 'Public link is on' },
  shareHint: {
    id: 'app.sml.promote.viewer.share.hint',
    defaultMessage: 'Anyone with the link can see this file. You can turn the link off at any time.',
  },
  shareLink: { id: 'app.sml.promote.viewer.share.button', defaultMessage: 'Share link' },
  shareNewLink: { id: 'app.sml.promote.viewer.share.newButton', defaultMessage: 'Share a new link' },
  linkOn: { id: 'app.sml.promote.viewer.share.linkOn', defaultMessage: 'Link on' },
  linkAddress: { id: 'app.sml.promote.viewer.share.address', defaultMessage: 'Public link address' },
  copy: { id: 'app.sml.promote.viewer.share.copy', defaultMessage: 'Copy' },
  copied: { id: 'app.sml.promote.viewer.share.copied', defaultMessage: 'Copied' },
  sharedOn: {
    id: 'app.sml.promote.viewer.share.sharedOn',
    defaultMessage:
      'Shared on {date}. The page shows this file, with the artist, the song and the SmartLink of the song.',
  },
  openPage: { id: 'app.sml.promote.viewer.share.openPage', defaultMessage: 'Open the page' },
  turnOff: { id: 'app.sml.promote.viewer.share.turnOff', defaultMessage: 'Turn off the link' },
  turnedOffNote: {
    id: 'app.sml.promote.viewer.share.turnedOffNote',
    defaultMessage: 'The link is off. Anyone with the old link sees “This link does not work”.',
  },
  toastCopied: { id: 'app.sml.promote.viewer.toast.copied', defaultMessage: 'Link copied' },
  toastTurnedOff: { id: 'app.sml.promote.viewer.toast.turnedOff', defaultMessage: 'Link turned off' },
  confirmTitle: { id: 'app.sml.promote.viewer.confirm.title', defaultMessage: 'Turn off the link?' },
  confirmBody: {
    id: 'app.sml.promote.viewer.confirm.body',
    defaultMessage:
      'The page stops working for everyone who has the link. If you share the file again, it gets a new link.',
  },
  confirmKeep: { id: 'app.sml.promote.viewer.confirm.keep', defaultMessage: 'Keep it on' },
  confirmTurnOff: { id: 'app.sml.promote.viewer.confirm.turnOff', defaultMessage: 'Turn it off' },
  errorNotReady: { id: 'app.sml.promote.viewer.error.notReady', defaultMessage: 'This file is not ready yet.' },
  errorFailed: { id: 'app.sml.promote.viewer.error.failed', defaultMessage: 'We could not make the link. Try again.' },
  errorTurnOff: {
    id: 'app.sml.promote.viewer.error.turnOff',
    defaultMessage: 'We could not turn off the link. Try again.',
  },
  demoNote: {
    id: 'app.sml.promote.viewer.demoNote',
    defaultMessage: 'The example artist is read only. Pick your own artist to share, post or make assets.',
  },
  videoError: {
    id: 'app.sml.promote.viewer.videoError',
    defaultMessage: 'This video does not play here. Download it to watch it.',
  },
});
